<template>
    <div class="main">
        <isNoInfo :isNolist="isNolist" :message="message" class="view_center"></isNoInfo>
    </div>
</template>
<script>
    import isNoInfo from '../../../../components/isNoInfo.vue';

    export default {
        components: {
            isNoInfo
        },
        data () {
            return {
                isNolist: true,
                message: '找不到该企业'
            }
        }
    }
</script>
<style lang="less" scoped>
.main {
    .view_center {

    }
}
</style>
